// extracted by mini-css-extract-plugin
module.exports = {"videoLoop":"VideoLoopWrap_videoLoop__vaHvI","selected":"VideoLoopWrap_selected__2htbp"};